import type { FundingApplicationSchemas } from "api-types";
import type { IntlShape } from "react-intl";

import type { FormattedFundingApplicationScreen } from "../../../queries/funding-application/queries";
import {
  hasAccountingSourceSelected,
  isMarketingConnectorSelected,
  isRevenueConnectorSelected,
} from "../../../utils/connectors";
import { MESSAGES } from "../message-definitions";

const stripUncheckedPlatforms = (selectedConnectors: { [x: string]: boolean } | undefined): string[] => {
  return selectedConnectors
    ? Object.entries(selectedConnectors)
        .filter(([, value]) => value)
        .map(([key]) => key)
    : [];
};

export const validateSelection = (
  selectedPlatforms: { [x: string]: boolean },
  intl: IntlShape,
  data: FormattedFundingApplicationScreen,
  fundingApplicationConfig: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen,
  isSkipRevenuePlatformSelected: boolean
): string[] => {
  const validationErrors = [];
  const hasRevenuePlatform = isRevenueConnectorSelected(stripUncheckedPlatforms(selectedPlatforms));

  const isRevenueMissing =
    !!fundingApplicationConfig.revenue?.platformRequired &&
    fundingApplicationConfig.revenue?.requiredConnectorSlugs?.length === 0 &&
    !hasRevenuePlatform &&
    !isSkipRevenuePlatformSelected;

  const isMarketingMissing =
    !!fundingApplicationConfig.marketing?.platformRequired &&
    fundingApplicationConfig.marketing?.requiredConnectorSlugs?.length === 0 &&
    !isMarketingConnectorSelected(stripUncheckedPlatforms(selectedPlatforms));

  const isAccountingMissing =
    !!fundingApplicationConfig.accounting?.platformRequired &&
    fundingApplicationConfig.accounting?.requiredConnectorSlugs?.length === 0 &&
    !hasAccountingSourceSelected(data);

  if (isRevenueMissing && isMarketingMissing && isAccountingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingRevenueMarketingAndAccounting));
  } else if (isRevenueMissing && isAccountingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingRevenueAndAccounting));
  } else if (isRevenueMissing && isMarketingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingRevenueAndMarketing));
  } else if (isMarketingMissing && isAccountingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingMarketingAndAccounting));
  } else if (isRevenueMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingRevenuePlatform));
  } else if (isMarketingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingMarketingPlatform));
  } else if (isAccountingMissing) {
    validationErrors.push(intl.formatMessage(MESSAGES.missingAccountingData));
  }
  return validationErrors;
};
